// extracted by mini-css-extract-plugin
module.exports = {"counter":"Counter_counter__1kH3q"};